import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Flashcards from "../Flashcards/Flashcards";


const letters = {
	"あ": "a",
	"い": "i",
	"う": "u",
	"え": "e",
	"お": "o",
	"か": "ka",
	"き": "ki",
	"く": "ku",
	"け": "ke",
	"こ": "ko",
	"が": "ga",
	"ぎ": "gi",
	"ぐ": "gu",
	"げ": "ge",
	"ご": "go",
	"さ": "sa",
	"し": "shi",
	"す": "su",
	"せ": "se",
	"そ": "so",
	"ざ": "za",
	"じ": "ji",
	"ず": "zu",
	"ぜ": "ze",
	"ぞ": "zo",
	"た": "ta",
	"ち": "chi",
	"つ": "tsu",
	"て": "te",
	"と": "to",
	"だ": "da",
	"ぢ": "dji",
	"づ": "dzu",
	"で": "de",
	"ど": "do",
	"な": "na",
	"に": "ni",
	"ぬ": "nu",
	"ね": "ne",
	"の": "no",
	"は": "ha",
	"ひ": "hi",
	"ふ": "fu",
	"へ": "he",
	"ほ": "ho",
	"ば": "ba",
	"び": "bi",
	"ぶ": "bu",
	"べ": "be",
	"ぼ": "bo",
	"ぱ": "pa",
	"ぴ": "pi",
	"ぷ": "pu",
	"ぺ": "pe",
	"ぽ": "po",
	"ま": "ma",
	"み": "mi",
	"む": "mu",
	"め": "me",
	"も": "mo",
	"や": "ya",
	"ゆ": "yu",
	"よ": "yo",
	"ら": "ra",
	"り": "ri",
	"る": "ru",
	"れ": "re",
	"ろ": "ro",
	"わ": "wa",
	"を": "wo",
	"ん": "n/m",
	"きゃ": "kya",
	"きゅ": "kyu",
	"きょ": "kyo",
	"ぎゃ": "gya",
	"ぎゅ": "gyu",
	"ぎょ": "gyo",
	"しゃ": "sha",
	"しゅ": "shu",
	"しょ": "sho",
	"じゃ": "ja",
	"じゅ": "ju",
	"じょ": "jo",
	"ちゃ": "cha",
	"ちゅ": "chu",
	"ちょ": "cho",
	"にゃ": "nya",
	"にゅ": "nyu",
	"にょ": "nyo",
	"ひゃ": "hya",
	"ひゅ": "hyu",
	"ひょ": "hyo",
	"びゃ": "bya",
	"びゅ": "byu",
	"びょ": "byo",
	"ぴゃ": "pya",
	"ぴゅ": "pyu",
	"ぴょ": "pyo",
	"みゃ": "mya",
	"みゅ": "myu",
	"みょ": "myo",
	"りゃ": "rya",
	"りゅ": "ryu",
	"りょ": "ryo",
	"っか": "kka",
	"っき": "kki",
	"っく": "kku",
	"っけ": "kke",
	"っこ": "kko",
	"っさ": "ssa",
	"っし": "sshi",
	"っす": "ssu",
	"っせ": "sse",
	"っそ": "sso",
	"った": "tta",
	"っち": "tchi",
	"っつ": "ttsu",
	"って": "tte",
	"っと": "tto",
	"っぱ": "ppa",
	"っぴ": "ppi",
	"っぷ": "ppu",
	"っぺ": "ppe",
	"っぽ": "ppo",
	"a": "あ",
	"i": "い",
	"u": "う",
	"e": "え",
	"o": "お",
	"ka": "か",
	"ki": "き",
	"ku": "く",
	"ke": "け",
	"ko": "こ",
	"ga": "が",
	"gi": "ぎ",
	"gu": "ぐ",
	"ge": "げ",
	"go": "ご",
	"sa": "さ",
	"shi": "し",
	"su": "す",
	"se": "せ",
	"so": "そ",
	"za": "ざ",
	"ji": "じ",
	"zu": "ず",
	"ze": "ぜ",
	"zo": "ぞ",
	"ta": "た",
	"chi": "ち",
	"tsu": "つ",
	"te": "て",
	"to": "と",
	"da": "だ",
	"dji": "ぢ",
	"dzu": "づ",
	"de": "で",
	"do": "ど",
	"na": "な",
	"ni": "に",
	"nu": "ぬ",
	"ne": "ね",
	"no": "の",
	"ha": "は",
	"hi": "ひ",
	"fu": "ふ",
	"he": "へ",
	"ho": "ほ",
	"ba": "ば",
	"bi": "び",
	"bu": "ぶ",
	"be": "べ",
	"bo": "ぼ",
	"pa": "ぱ",
	"pi": "ぴ",
	"pu": "ぷ",
	"pe": "ぺ",
	"po": "ぽ",
	"ma": "ま",
	"mi": "み",
	"mu": "む",
	"me": "め",
	"mo": "も",
	"ya": "や",
	"yu": "ゆ",
	"yo": "よ",
	"ra": "ら",
	"ri": "り",
	"ru": "る",
	"re": "れ",
	"ro": "ろ",
	"wa": "わ",
	"wo": "を",
	"n/m": "ん",
	"kya": "きゃ",
	"kyu": "きゅ",
	"kyo": "きょ",
	"gya": "ぎゃ",
	"gyu": "ぎゅ",
	"gyo": "ぎょ",
	"sha": "しゃ",
	"shu": "しゅ",
	"sho": "しょ",
	"ja": "じゃ",
	"ju": "じゅ",
	"jo": "じょ",
	"cha": "ちゃ",
	"chu": "ちゅ",
	"cho": "ちょ",
	"nya": "にゃ",
	"nyu": "にゅ",
	"nyo": "にょ",
	"hya": "ひゃ",
	"hyu": "ひゅ",
	"hyo": "ひょ",
	"bya": "びゃ",
	"byu": "びゅ",
	"byo": "びょ",
	"pya": "ぴゃ",
	"pyu": "ぴゅ",
	"pyo": "ぴょ",
	"mya": "みゃ",
	"myu": "みゅ",
	"myo": "みょ",
	"rya": "りゃ",
	"ryu": "りゅ",
	"ryo": "りょ",
	"kka": "っか",
	"kki": "っき",
	"kku": "っく",
	"kke": "っけ",
	"kko": "っこ",
	"ssa": "っさ",
	"sshi": "っし",
	"ssu": "っす",
	"sse": "っせ",
	"sso": "っそ",
	"tta": "った",
	"tchi": "っち",
	"ttsu": "っつ",
	"tte": "って",
	"tto": "っと",
	"ppa": "っぱ",
	"ppi": "っぴ",
	"ppu": "っぷ",
	"ppe": "っぺ",
	"ppo": "っぽ",
};

function Hiragana() {
	return (
		<>
			<Container maxWidth="sm">
				<Box mt={5} sx={{ textAlign: "center" }}>
					<section>
						<Typography variant="h4">Hiragana</Typography>
					</section>
					<section>
						<Flashcards dictionary={letters} />
					</section>
				</Box>
			</Container>
		</>
	);
}

export default Hiragana;